// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";

class TakeDepositActionService {
  private dispatch = useDispatch();

  public async getDepositDetailsData(
    depositId: string | undefined
  ): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<{
        data: any[];
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/deposit/${depositId}`);
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/deposit/take-action/${depositId}`
      );
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async takeAction(
    depositId: string | undefined,
    action: string,
    value: string
  ): Promise<string | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    this.dispatch({ type: LOADING, payload: true });
    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/deposit/${depositId}/review`, {
        approved: action === "approve" ? true : false,
        [action === "approve" ? "transactionId" : "statusReason"]: value,
      });
      action === "approve"
        ? toast.success("Deposit approved successfully")
        : toast.success("Deposit rejected successfully");
      return "success";
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/deposit/take-action/${depositId}`
      );
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default TakeDepositActionService;
